"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var config_1 = require("@pbl/pbl-react-core/lib/config/config");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var yup = __importStar(require("yup"));
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../config/constants"));
var validation_1 = __importDefault(require("../../../config/validation"));
var profile_validations_1 = require("../../../utils/profile-validations");
var AddressStyle_1 = __importDefault(require("./AddressStyle"));
var AutocompleteFieldsId;
(function (AutocompleteFieldsId) {
    AutocompleteFieldsId["COUNTRY"] = "country";
    AutocompleteFieldsId["STATE"] = "state";
    AutocompleteFieldsId["CITY"] = "city";
})(AutocompleteFieldsId || (AutocompleteFieldsId = {}));
var AddressComponent = function (props) {
    var theme = (0, styles_1.useTheme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var classes = (0, AddressStyle_1.default)(theme)();
    var countryRef = (0, react_1.useRef)(null);
    var stateRef = (0, react_1.useRef)(null);
    var cityRef = (0, react_1.useRef)(null);
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: {
            margin: theme.spacing(2, 0, 1, 2),
            color: colorsV2_1.default.palette.neutralsN700.hex()
        }
    };
    var setAriaControlsAttribute = function (ref, id, isClosed) {
        var ariaControlsValue = isClosed ? id : "".concat(id, "-options");
        if (ref.current) {
            ref.current.setAttribute('aria-controls', ariaControlsValue);
        }
    };
    (0, react_1.useEffect)(function () {
        var initializeAriaAttributes = function (ref, id) {
            setAriaControlsAttribute(ref, id, true);
        };
        initializeAriaAttributes(countryRef, AutocompleteFieldsId.COUNTRY);
        initializeAriaAttributes(stateRef, AutocompleteFieldsId.STATE);
        initializeAriaAttributes(cityRef, AutocompleteFieldsId.CITY);
    }, []);
    var address = props.address, handleAddressChange = props.handleAddressChange, fieldVariant = props.fieldVariant, fieldClass = props.fieldClass, fieldAutocompleteClass = props.fieldAutocompleteClass, showMandatory = props.showMandatory, disable = props.disable, defaultCountryCode = props.defaultCountryCode, defaultStateCode = props.defaultStateCode;
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)([]), countries = _b[0], setCountries = _b[1];
    var _c = (0, react_1.useState)([]), cities = _c[0], setCities = _c[1];
    var _d = (0, react_1.useState)([]), states = _d[0], setStates = _d[1];
    var selectedCountry = countries.find(function (country) { return address.country === country.name || address.countryCode === country.iso2; });
    var selectedState = states.find(function (st) { return address.state.toLowerCase() === st.name.toLowerCase(); });
    var selectedCity = cities.find(function (cty) { return address.city.toLowerCase() === cty.name.toLowerCase(); });
    (0, react_1.useEffect)(function () {
        if (!loading) {
            document.querySelectorAll('.MuiAutocomplete-clearIndicator').forEach(function (el) {
                el.removeAttribute('tabindex');
            });
        }
    }, [loading]);
    var getCountries = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, statesResponse, citiesResponse, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    return [4, services_1.AddressService.getAllCountriesV1()];
                case 1:
                    response = _d.sent();
                    setCountries(response);
                    if (!(defaultCountryCode && defaultStateCode && states.length <= 0)) return [3, 4];
                    selectedCountry = response.find(function (item) { return item.iso2.toUpperCase() === defaultCountryCode; });
                    if (!(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.id)) return [3, 4];
                    return [4, services_1.AddressService.getStatesV1(selectedCountry.id)];
                case 2:
                    statesResponse = _d.sent();
                    setStates(statesResponse);
                    selectedState = statesResponse.find(function (st) { return st.stateCode === defaultStateCode; });
                    handleAddressChange(__assign(__assign({}, address), { country: (_a = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.name) !== null && _a !== void 0 ? _a : '', countryCode: (_b = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.iso2) !== null && _b !== void 0 ? _b : '', state: (_c = selectedState === null || selectedState === void 0 ? void 0 : selectedState.name) !== null && _c !== void 0 ? _c : '' }));
                    if (!(selectedState === null || selectedState === void 0 ? void 0 : selectedState.id)) return [3, 4];
                    return [4, services_1.AddressService.getCitiesV1(selectedState.id)];
                case 3:
                    citiesResponse = _d.sent();
                    setCities(citiesResponse);
                    _d.label = 4;
                case 4:
                    setLoading(false);
                    return [3, 6];
                case 5:
                    e_1 = _d.sent();
                    console.error(e_1);
                    setLoading(false);
                    return [3, 6];
                case 6: return [2];
            }
        });
    }); };
    var getStates = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, services_1.AddressService.getStatesV1(id)];
                case 2:
                    response = _a.sent();
                    setStates(response);
                    setLoading(false);
                    return [3, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error(e_2);
                    setLoading(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var getCities = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, services_1.AddressService.getCitiesV1(id)];
                case 2:
                    response = _a.sent();
                    setCities(response);
                    setLoading(false);
                    return [3, 4];
                case 3:
                    e_3 = _a.sent();
                    console.error(e_3);
                    setLoading(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getCountries();
    }, []);
    (0, react_1.useEffect)(function () {
        if (countries.length > 0) {
            var country = countries.find(function (item) { return address.country === item.name || address.countryCode === item.iso2; });
            if (country) {
                getStates(country.id);
            }
        }
    }, [countries, address.country, address.countryCode]);
    (0, react_1.useEffect)(function () {
        if (states.length > 0) {
            if (address.state === constants_1.default.DEFAULT_STATE_CODE ||
                address.state.toLowerCase() === constants_1.default.DEFAULT_STATE_NAME.toLowerCase()) {
                address.state = constants_1.default.DEFAULT_STATE_NAME;
            }
            var state = states.find(function (st) { return address.state === st.name; });
            if (state) {
                getCities(state.id);
            }
        }
    }, [states, address.state]);
    var handleChangeCountry = function (_event, value) {
        if (countries.length === 0)
            return;
        if (!value) {
            setCities([]);
            setStates([]);
            handleAddressChange(__assign(__assign({}, address), { country: '', countryCode: '', state: '', city: '' }));
        }
        else {
            var selected = countries.find(function (item) { return item.name === value.name; });
            var countryCode = '';
            if (selected) {
                countryCode = selected.iso2;
                getStates(selected.id);
            }
            handleAddressChange(__assign(__assign({}, address), { country: value.name, countryCode: countryCode, state: '', city: '' }));
        }
    };
    var handleChangeState = function (_event, value) {
        var _a;
        if (states.length === 0)
            return;
        var selected = states.find(function (st) { return st.name === (value === null || value === void 0 ? void 0 : value.name); });
        if (selected) {
            getCities(selected.id);
        }
        handleAddressChange(__assign(__assign({}, address), { state: (_a = value === null || value === void 0 ? void 0 : value.name) !== null && _a !== void 0 ? _a : '', city: '' }));
    };
    var handleChangeCity = function (_event, value) {
        var _a;
        handleAddressChange(__assign(__assign({}, address), { city: (_a = value === null || value === void 0 ? void 0 : value.name) !== null && _a !== void 0 ? _a : '' }));
    };
    var autoCompleteMap = {
        Country: 'country-name',
        State: 'address-level1',
        City: 'address-level2',
        'Zip Code': 'postal-code'
    };
    var getOptionLabel = function (option) { return option.name; };
    var renderOption = function (option) { return option.name; };
    var inputHasError = function (field) {
        switch (field) {
            case 'country':
                return props.countryError;
            case 'state':
                return props.stateError;
            case 'city':
                return props.cityError;
            default:
                return undefined;
        }
    };
    var renderAutocompleteInput = function (value, label, params, fieldId) {
        var error = inputHasError(label);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle },
                label,
                labelProps.isRequiredLabel ? ' *' : '')),
            react_1.default.createElement(package_1.TextFieldValidator, __assign({}, params, { id: fieldId, label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? label : null, variant: fieldVariant, inputProps: __assign(__assign({}, params.inputProps), { id: fieldId, autoComplete: autoCompleteMap[label] || 'off', 'aria-required': showMandatory ? true : undefined, 'aria-autocomplete': 'list', 'aria-label': label }), validationSchema: showMandatory ? yup.string().required() : undefined, value: value ? value.name : undefined, error: error, helperText: value || label === 'City' ? null : t("address.".concat(label), "Enter a valid ".concat(label)) }))));
    };
    var handleTextChange = function (event) {
        var _a;
        handleAddressChange(__assign(__assign({}, address), (_a = {}, _a[event.target.id] = event.target.value, _a)));
    };
    var isCanadaZipCodeValidationOn = !config_1.react_core_config.internalConfig.usaOnlyZipcode &&
        (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.iso2) === validation_1.default.canadianCountryCode;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle }, "Street Address",
            labelProps.isRequiredLabel ? ' *' : '')),
        react_1.default.createElement(package_1.TextFieldValidator, { id: "address1", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Street Address' : null, autoComplete: "address-line1", className: (0, classnames_1.default)(fieldClass, classes.field), value: address.address1, inputProps: {
                maxLength: validation_1.default.maxAddressLength,
                'aria-required': showMandatory ? true : undefined,
                'aria-label': 'Street Address'
            }, onChange: handleTextChange, validationSchema: showMandatory ? profile_validations_1.addressValidator : undefined, variant: fieldVariant, error: props.address1Error, disabled: !!disable }),
        !labelProps.useAlternateTextField ? null : (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle }, "Apartment / Suite #",
            !labelProps.isRequiredLabel ? ' *' : '')),
        react_1.default.createElement(TextField_1.default, { id: "address2", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Apartment / Suite #' : null, autoComplete: "address-line2", className: (0, classnames_1.default)(fieldClass, classes.field), value: address.address2, inputProps: { maxLength: validation_1.default.maxAddressLength, 'aria-label': 'Apartment / Suite #' }, onChange: handleTextChange, variant: fieldVariant, error: props.apartmentNumberError, disabled: !!disable }),
        react_1.default.createElement(Autocomplete_1.default, { "aria-label": "Country", id: AutocompleteFieldsId.COUNTRY, ref: countryRef, className: (0, classnames_1.default)(fieldAutocompleteClass, classes.fieldAutocomplete), options: countries, autoHighlight: true, onChange: handleChangeCountry, getOptionLabel: getOptionLabel, renderOption: renderOption, value: selectedCountry || null, noOptionsText: loading ? 'Loading...' : 'No Options', disabled: !!disable || countries.length === 0, onOpen: function () { return setAriaControlsAttribute(countryRef, AutocompleteFieldsId.COUNTRY); }, onClose: function () { return setAriaControlsAttribute(countryRef, AutocompleteFieldsId.COUNTRY, true); }, renderInput: function (params) {
                return renderAutocompleteInput(selectedCountry, 'Country', params, AutocompleteFieldsId.COUNTRY);
            } }),
        react_1.default.createElement(Autocomplete_1.default, { "aria-label": "State", id: AutocompleteFieldsId.STATE, ref: stateRef, className: (0, classnames_1.default)(fieldAutocompleteClass, classes.fieldAutocomplete), options: states, autoHighlight: true, onChange: handleChangeState, getOptionLabel: getOptionLabel, renderOption: renderOption, value: selectedState || null, noOptionsText: loading ? 'Loading...' : 'No Options', disabled: !!disable || states.length === 0, onOpen: function () { return setAriaControlsAttribute(stateRef, AutocompleteFieldsId.STATE); }, onClose: function () { return setAriaControlsAttribute(stateRef, AutocompleteFieldsId.STATE, true); }, renderInput: function (params) {
                return renderAutocompleteInput(selectedState, 'State', params, AutocompleteFieldsId.STATE);
            } }),
        react_1.default.createElement(Autocomplete_1.default, { "aria-label": "City", id: AutocompleteFieldsId.CITY, ref: cityRef, className: (0, classnames_1.default)(fieldAutocompleteClass, classes.fieldAutocomplete), options: cities, autoHighlight: true, onChange: handleChangeCity, getOptionLabel: getOptionLabel, renderOption: renderOption, value: selectedCity || null, noOptionsText: loading ? 'Loading...' : 'No Options', disabled: !!disable || cities.length === 0, onOpen: function () { return setAriaControlsAttribute(cityRef, AutocompleteFieldsId.CITY); }, onClose: function () { return setAriaControlsAttribute(cityRef, AutocompleteFieldsId.CITY, true); }, renderInput: function (params) {
                return renderAutocompleteInput(selectedCity, 'City', params, AutocompleteFieldsId.CITY);
            } }),
        (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle },
            'Zip Code',
            labelProps.isRequiredLabel ? ' *' : '')),
        react_1.default.createElement(package_1.TextFieldValidator, { id: "zipCode", label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? 'Zip Code' : null, autoComplete: "postal-code", className: (0, classnames_1.default)(fieldClass, classes.field), value: address.zipCode, inputProps: {
                maxLength: isCanadaZipCodeValidationOn
                    ? validation_1.default.zipCodeLength
                    : validation_1.default.zipCodeUSALength,
                'aria-required': showMandatory ? true : undefined,
                'aria-label': 'Zip Code'
            }, onChange: handleTextChange, validationSchema: showMandatory ? (0, profile_validations_1.zipCodeValidator)(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.iso2) : undefined, variant: fieldVariant, error: props.zipCodeError, disabled: !!disable, helperText: isCanadaZipCodeValidationOn
                ? t('address.zipCode.canada', 'Enter 6 characters (Ex: A1B2C3)')
                : t('address.zipCode.usa', 'Enter 5 digits (Ex: 12345)') })));
};
exports.default = AddressComponent;
//# sourceMappingURL=Address.js.map